<ng-container *ngIf="_group && domainNames?.length > 1">
  <div [formGroup]="_group" class="additional-options domain-select-div" *ngIf="domainNames?.length > 1 && _group.contains(controlName)">
    <span class="domain-label">{{labelKey | translate}}</span>
    <mat-radio-group [formControlName]="controlName" class="domain-radio-group">
      <mat-radio-button class="domain-item" [value]="domain"
                        *ngFor="let domain of domainNames">{{domain}}</mat-radio-button>
    </mat-radio-group>
  </div>
</ng-container>
